export const GA_MEASUREMENT_ID = import.meta.env.VITE_PUBLIC_GA_MEASUREMENT_ID || "";

declare global {
  interface Window {
    gtag: (...args: any[]) => void;
    dataLayer: any[];
  }
}

/** GA 스크립트 동적 로드 (index.html 수정 없이) */
export function initGA() {
  if (!GA_MEASUREMENT_ID) return;
  if (document.querySelector(`script[src*="googletagmanager"]`)) return;

  const script = document.createElement("script");
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  script.async = true;
  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];
  window.gtag = function gtag() {
    // eslint-disable-next-line prefer-rest-params
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", GA_MEASUREMENT_ID);
}

/** 페이지뷰 전송 */
export function pageview(url: string) {
  if (!GA_MEASUREMENT_ID) return;
  window.gtag?.("config", GA_MEASUREMENT_ID, { page_path: url });
}

/** 커스텀 이벤트 전송 */
export function event(
  action: string,
  params?: Record<string, string | number | boolean>,
) {
  if (!GA_MEASUREMENT_ID) return;
  window.gtag?.("event", action, params);
}
